<template>
  <div id="header-panel" class="header-panel">
    <!-- временно скрытый прогресс-бар для статей -->

    <!-- <div v-if="isProgressBarShown" ref="progress" class="progress-bar"></div> -->
    <div class="container">
      <div class="header-panel__inner">
        <a href="/" class="header__logo">
          <img
            src="~/assets/img/main/logo--mts.svg"
            alt="Webinar"
            class="header-panel__logo_img"
            width="104"
            height="40"
          />
        </a>
        <HeaderMenuListDesktop
          :class="['header-panel__menu-list']"
          @openMenu="$emit('openMenu')"
          @closeMenu="$emit('closeMenu')"
        />
        <div class="header-panel__btn-list">
          <template v-if="anchorLink !== ''">
            <VButtonMTSV2
              v-scroll-to="{
                el: anchorLink,
                offset: 0,
                duration: 0,
              }"
              class="header-panel__btn --test --violet-gradient --m"
              ><span>{{ btnText }}</span></VButtonMTSV2
            >
          </template>
          <template v-else>
            <VButtonLinkMTSV2 href="/user" class="header-panel__btn --test --violet-gradient --m"
              ><span>Попробовать бесплатно</span></VButtonLinkMTSV2
            >
          </template>

          <VButtonLinkMTSV2
            href="javascript:void(0);"
            class="header-panel__btn --signin --grey --m"
            @click="sendMetricsSigninClient"
          >
            <span>Войти</span>
          </VButtonLinkMTSV2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPanelMixin from '~/components/Desktop/Header/mixins/HeaderPanelMixin'
import HeaderMenuListDesktop from '~/components/Desktop/Header/HeaderMenuListDesktop.vue'
import VButtonLinkMTSV2 from '~/components/Common/MTS/VButtonLinkMTSV2.vue'
import VButtonMTSV2 from '~/components/Common/MTS/VButtonMTSV2.vue'

export default {
  name: 'HeaderPanelDesktop',
  components: { VButtonLinkMTSV2, VButtonMTSV2, HeaderMenuListDesktop },
  mixins: [HeaderPanelMixin],
  data() {
    return {
      forms: [],
    }
  },
}
</script>
<style lang="scss" scoped>
.header-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 14px 0;
  transform: translateY(-50vh);
  transition: all 0.3s ease;
  background: #fff;
  border-bottom: 1px solid rgba(150, 159, 168, 0.2);
  font-family: 'MTS Compact', Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  z-index: 449;

  @include screen-down('lg') {
    transform: translateY(-100%);
    padding: 16px 0;
  }

  &.visible {
    transform: translateY(0);
  }

  .container {
    max-width: 1440px;
    padding-left: 32px;
    padding-right: 32px;
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 44px;
    position: relative;
  }

  &__btn {
    @include screen-up('lg') {
      flex: 0 auto;
    }

    &-list {
      display: flex;
      column-gap: 16px;
      justify-content: flex-end;
    }
    &-icon {
      flex: 1 24px;
    }
  }

  &__menu-list {
    flex: 1;
    justify-self: flex-start;
    ::v-deep & {
      @include screen-down('xl'){
        display: none;
      }
    }
  }
}

// .menu {
//   margin: 0 0 0 auto;
// }

// .progress-bar {
//   position: relative;
//   top: -14px;
//   height: 5px;
//   background: #262626;
// }
</style>
